export default __webpack_public_path__ + "static/media/logo.7f4b4a03.svg";